import { render } from "./CompanyPage.vue?vue&type=template&id=21c93276"
import script from "./CompanyPage.vue?vue&type=script&lang=js"
export * from "./CompanyPage.vue?vue&type=script&lang=js"

import "./CompanyPage.vue?vue&type=style&index=0&id=21c93276&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__